import React from 'react';
import styled from 'styled-components';
import SmallCalendar from "../../../components/common/SmallCalendar";

const CalendarPopup = (props) => {
return(
  <Container>
      <SmallCalendar {...props} />
  </Container>
)

}
export default CalendarPopup;

const Container = styled.div`

`;